export default "__VITE_ASSET__Cf1TPDhF__"